
import { PointInfo } from "../WalltoFittingInfo";
import * as THREE from 'three';

export class PointToPointList {
    constructor(private pointList: PointInfo[], private rad: number) {
        ;
    }

    public execute(): PointInfo[] {

        return this.pointList.map((info: PointInfo) => {
            const point = info.point.clone()
            point.applyAxisAngle(new THREE.Vector3(0, 1, 0), this.rad);
            return {
                point: point,
                isExist: info.isExist,
                isDelete: info.isDelete
            };
        });

    }
}